<template lang="pug">
  b-modal#modal-confirm-delete-quotation(centered, size="lg", @ok="ok", @shown="onModalShown")
    //- header
    template(#modal-header="{cancel}")
      button.close(title="閉じる", @click="cancel") ×
    //- body
    template(#default)
      //- メッセージフォーム
      app-messages(:errorMessages="errors")
      h5.text-center 以下の見積書を削除しますか？
      b-container
        b-row(v-for="item in items")
          b-col(cols=6)
            b-form-text.text-right {{item.label}}
          b-col(cols=6)
            b-form-text {{item.data}}
    //- footer
    template(#modal-footer="{ ok, cancel }")
      b-button(variant="outline-secondary", size="sm", @click="cancel", :disabled="isDeleteLoading") キャンセル
      b-button(variant="danger", size="sm", @click="ok", :disabled="isDeleteLoading") 削除
</template>

<script>
import Api from "@/repositories/api";
import AppMessages from '@/components/AppMessages.vue';

const S214QuotationRepository = Api.get("s214Quotation");

export default {
  name: 'ModalConfirmDeleteQuotation',
  props: {
    quotation_info: {type: Object, required: true}
  },
  components: {
    AppMessages
  },
  data() {
    return {
      // 見積書情報
      items: [
        { label: '見積書番号', physical_name: 'quotation_no' , data: '' },
        { label: '作成者', physical_name: 'created_user' , data: '' },
        { label: '有効期限', physical_name: 'expiration_date' , data: '' },
        { label: '見積書種類', physical_name: 'quotation_kind' , data: '' },
        { label: '見積金額', physical_name: 'quoted_amount' , data: '' },
      ],

      // エラーメッセージ
      errors: [],

      // 削除処理読み込み中フラグ
      isDeleteLoading: false,
    }
  },
  methods: {
    /**
     * 「削除」ボタン選択処理
     */
    ok (bvModalEvent) {
      // ダイアログが閉じるイベントを停止
      bvModalEvent.preventDefault()

      // 削除処理読み込み中
      this.isDeleteLoading = true

      // エラーメッセージの初期化
      this.errors = []

      // S21405_見積書削除処理
      S214QuotationRepository.delete({'estimate_branch': this.quotation_info.estimate_branch})
        // 成功時
        .then(() => {
          // ダイアログを閉じる
          this.$bvModal.hide('modal-confirm-delete-quotation')

          // 最新の見積一覧情報を取得する
          this.$emit('getQuotation');
        })
        .catch((error) => {
          // エラーレスポンスがある場合
          if (error.response && 'status' in error.response) {
            // 共通のエラー処理
            this.apiError(error, '見積書削除処理', "Support")

            // バリデーションエラー
            if (error.response.data.error_list) {
              for (let errorData of error.response.data.error_list) {
                // エラーメッセージをセット
                this.errors.push(errorData.error_msg)
              }
            }
          }
          // エラーレスポンスがない場合
          else {
            // エラーメッセージをセットする
            this.setErrors(error)
          }
        })
        .finally(() => {
          // 削除処理読み込み終了
          this.isDeleteLoading = false
        })
    },
    /**
     * モーダルを開いた際の処理
     */
    onModalShown() {
      // モーダルが表示されたときにデータを設定
      this.items.forEach((item) => {
        item.data = this.quotation_info[item.physical_name]
      })
    }
  },
}
</script>
